import { DreamBlock, DreamValue, TextLeaf, fonts } from '@typedream/core';
import { uniq } from 'lodash';

export function getFontListFromEditor(contents: DreamValue) {
  let loadedFonts: string[] = ['Inter'];

  contents.forEach((content: DreamBlock) => {
    const { fontFamily } = content as unknown as TextLeaf;
    if (fontFamily) {
      if (fontFamily in fonts) {
        loadedFonts.push(fonts[fontFamily]);
      } else {
        loadedFonts.push(fontFamily);
      }
    }

    if ((content.children || []).length > 0) {
      loadedFonts = [...loadedFonts, ...getFontListFromEditor(content.children as DreamValue)];
    }
  });

  return uniq(loadedFonts);
}
